export const muiSelectErrorMultiModeTypeMismatch = () =>
  new Error(`MuiSelect: The provided model input does not match the
control's multi mode. In single mode, a single value has to be provided, and in multi mode an array is expected.`);

export const muiSelectErrorMultiModeChangeAfterInit = () =>
  new Error(`MuiSelect: The multi mode of the select cannot be changed
after initialization.`);
